import Vue from "vue";
import App from "./App";
import Axios from "axios";
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import { routes } from "./routes/index";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/style.css";
import "./assets/css/default.css";
import VueCookies from "vue-cookies";
import money from 'v-money';
import VModal from 'vue-js-modal'
import Vuex from 'vuex'
import velocity      from 'velocity-animate'
import Notifications from 'vue-notification'
 
/*
or for SSR:
import Notifications from 'vue-notification/dist/ssr.js'
*/
 
Vue.use(Notifications, { velocity })


window.EventBus = new Vue();

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    chegouMonthStepQuatro: false,
    chegouStepQuatro: false,
    trimestral: false,
    presumido: false,
    importouEcf: false,
    ecf: 1,
    idcliente: '',
    user: '',
    importacaostep: 1,
    simplesstep: 'total',
    envioCalculo: [],
    spinner:false,
    monthstep:1,
    month:1,
    cnaev:333,
    step: 1,
    resultstep:1,
    totalresultstep:1,
    resultado: false,
    resultadocalculos: [],
    resultadodeducao: [],
    cnaeselecionados: [],
    api: [
      //variavel que envia os titulos para o lefinput gerar os campos de cada input <
      //1
      [],
      //2
      [],
      //3
      [],
      //4
      [],
      //5
      [
        { titulo: "ICMS SOBRE VENDAS", info: "", value:[], input: true, },
        {
          titulo: "PIS/PASEP SOBRE A RECEITA BRUTA (Lucro Real)",
          input: true,
          info: "",value:[]
        },
        {
          titulo: "COFINS SOBRE A RECEITA BRUTA (Lucro Real)",
          input: true,
          info: "",value:[]
        },
        {
          titulo: "PIS/PASEP SOBRE A RECEITA BRUTA (Lucro Presumido)",
          input: true,
          info: "",value:[]
        },
        {
          titulo: "COFINS SOBRE A RECEITA BRUTA (Lucro Presumido)",
          input: true,
          info: "",value:[] 
        },
        { titulo: "ISS", info: "",value:[], input: true, },
      ],
      //6
      [
        {
          titulo: "DEVOLUÇÕES DE VENDAS E VENDAS CANCELADAS",
          info: "", value: [],
        },
        { titulo: "DESCONTOS INCONDICIONAIS", info: "", value: [], },
        {
          titulo: "TOTAL DAS DEDUÇÕES DA RECEITA BRUTA (LUCRO REAL)",
          input: false,
          info: "",
          value: []
        },
        {
          titulo: "TOTAL DAS DEDUÇÕES DA RECEITA BRUTA (LUCRO PRESUMIDO)",
          input: false,
          info: "",
          value: []
        },
      ],
      //7
      [
        {
          titulo:
            "ESTOQUE INICIAL NO PERÍODO DE APURAÇÃO (matérias primas e insumos)",
          info: "",value: []
        },
        { titulo: "COMPRAS DE MATÉRIA PRIMA E INSUMOS", info: "",value: [] },
        {
          titulo: "( - ) ESTOQUE FINAL (matérias primas e insumos)",
          info: "",value: []
        },
        {
          titulo:
            "ESTOQUE INICIAL NO PERÍODO DE APURAÇÃO (mercadoria para revenda)",
          info: "",value: []
        },
        { titulo: "COMPRAS DE MERCADORIAS PARA REVENDA", info: "",value: [] },
        {
          titulo: "( - ) ESTOQUE FINAL (mercadorias para revenda)",
          info: "",value: []
        },
        { titulo: "INSUMOS APLICADOS NA PRESTAÇÃO DE SERVIÇOS", info: "",value: [] },
        {
          titulo: "TOTAL PARCIAL DOS CUSTOS NA ATIVIDADE INDUSTRIAL",
          input: false,
          info: "",value: []
        },
        {
          titulo: "TOTAL PARCIAL DOS CUSTOS NA ATIVIDADE COMERCIAL",
          input: false,
          info: "",value: []
        },
        {
          titulo:
            "TOTAL PARCIAL DOS CUSTOS NA ATIVIDADE DE PRESTAÇÃO DE SERVIÇOS",
          input: false,
          info: "",value: []
        },
      ],
      //8
      [
        { titulo: "Energia elétrica e Energia Térmica", info: "",value: [] },
        {
          titulo:
            "Manutenção de Máquinas e Equipamentos (Produção e Prestação de serviços)",
          info: "",value: []
        },
        {
          titulo: "Combustíveis (Produção e Prestação de Serviços)",
          info: "",value: []
        },
        {
          titulo:
            "Equipamento de Proteção Individual (Produção e Prestação de serviços)",
          info: "",value: []
        },
        {
          titulo:
            "Encargos de Depreciação Máquinas e Equipamentos (Produção e Prestação de Serviços)",
          info: "",value: []
        },
        { titulo: "Custos no Desenvolvimento de Produtos", info: "",value: [] },
        { titulo: "Encargos de Amortização", info: "",value: [] },
        {
          titulo:
            "Encargos de Depreciação de Veículos (Prestação de Serviços)",
          info: "",value: []
        },
        { titulo: "Serviços de Terceiros (Pessoa Jurídica)", info: "",value: [] },
        { titulo: "Seguros (Produção e Prestação de Serviços)", info: "",value: [] },
        {
          titulo:
            "TOTAL DOS DEMAIS CUSTOS DE PRODUÇÃO OU PRESTAÇÃO DE SERVIÇOS",
          info: "",
          input: false,value: []
        },
      ],
      //9
      [
        { titulo: "Pró-labore", info: "",value: [] },
        { titulo: "Salários, Férias, 13º salários", info: "",value: [] },
        { titulo: "Serviços de Terceiros (Pessoa Física)", info: "",value: [] },
        { titulo: "FGTS", input: false, info: "",value: [] },
        { titulo: "PREVIDÊNCIA SOCIAL", input: false, info: "",value: [] },
        {
          titulo: "TOTAL DA FOLHA DE PAGAMENTO E ENCARGOS",
          input: false,
          info: "",value: []
        },
      ],
      //10
      [
        {
          titulo:
            "Aluguéis de prédios, máquinas e equipamentos, pagos a pessoa jurídica, utilizados nas atividades da empresa",
          info: "",value: []
        },
        {
          titulo:
            "Valor das contraprestações de operações de arrendamento mercantil de pessoa jurídica",
          info: "",value: []
        },
        {
          titulo: "Armazenagem de mercadoria e frete na operação de venda",
          info: "",value: []
        },
        { titulo: "Encargos de Depreciação em Edificações", info: "" ,value: []},
        { titulo: "Vale-Transporte", info: "",value: [] },
        { titulo: "Vale-Alimentação", info: "",value: [] },
        { titulo: "Uniformes", info: "",value: [] },
        { titulo: "EPI (Atividade Administrativa ou Comercial)", info: "",value: [] },
        { titulo: "Despesas com Vendas", info: "",value: [] },
        {
          titulo:
            "Manutenção de Veículos (Não utilizados na prestação de serviços)",
          info: "",value: []
        },
      ],
      //11
      [
        {
          titulo:
            "Combustível (Não utilizados na Produção ou Prestação de Serviços)",
          info: "",value: []
        },
        { titulo: "Água e Esgoto", info: "",value: [] },
        { titulo: "Telefone, Internet", info: "",value: [] },
        { titulo: "Seguros", info: "",value: [] },
        { titulo: "Materiais de Consumo e Limpeza", info: "",value: [] },
        { titulo: "Previdência Privada", info: "",value: [] },
        {
          titulo: "Plano de Saúde, Assistência Médica e Odontológica",
          info: "",value: []
        },
        { titulo: "Gratificação de Administradores", info: "" ,value: []},
        { titulo: "Participação nos Lucros e Resultados", info: "" ,value: []},
        { titulo: "Comissões e Representações", info: "",value: [] },
      ],
      //12
      [
        { titulo: "Propaganda e Publicidade", info: "",value: []},
        { titulo: "Brindes", info: "" ,value: []},
        { titulo: "Amostra Grátis", info: "",value: [] },
        {
          titulo: "Serviços Pessoa Jurídica (Contábil, Jurídicos ...)",
          info: "",value: []
        },
        { titulo: "Viagens", info: "",value: [] },
        { titulo: "Demais despesas administrativas", info: "",value: [] },
        { titulo: "Demais despesas com vendas", info: "",value: [] },
        { titulo: "Demais despesas gerais", info: "" ,value: []},
        { titulo: "Multas e Autuações", info: "",value: [] },
        {
          titulo: "TOTAL DAS DESPESAS OPERACIONAIS GERAIS",
          input: false,
          info: "",value: []
        },
        {
          titulo: "TOTAL DOS CUSTOS E DESPESAS DA ATIVIDADE EM GERAL",
          input: false,
          info: "",value: []
        },
      ],
      //13
      [
        { titulo: "Variações Cambiais Ativas", info: "" ,value: []},
        {
          titulo:
            "Ganhos Auferidos no Mercado de Renda Variável, exceto Day-Trade",
          info: "",value: []
        },
        { titulo: "Ganhou em Operações Day-Trade", info: "",value: [] },
        { titulo: "Receitas de Juros sobre o Capital Próprio", info: "",value: [] },
        { titulo: "Outras Receitas Financeiras", info: "",value: [] },
        { titulo: "Resultados Positivos", info: "",value: [] },
        {
          titulo: "Rendimentos e Ganhos de Capital Auferidos no Exterior",
          info: "",value: []
        },
        {
          titulo:
            "Reversão das Perdas Estimadas Decorrentes de Teste de Recuperabilidade (Impairment)",
          info: "",value: []
        },
        { titulo: "Prêmios Recebidos; Doações e Subvenções", info: "" ,value: []},
        { titulo: "Subvenção Governamental", info: "",value: [] },
        {
          titulo: "Receita de Aluguel de Bens (não objeto da empresa)",
          info: "",value: []
        },
        { titulo: "Créditos Fiscais Presumidos", info: "",value: [] },
        { titulo: "Multas e Outras Vantagens Recebidas", info: "",value: [] },
        {
          titulo:
            "Lucros e Dividendos Derivados de Participações Societárias Avaliadas pelos Custos de Aquisição",
          info: "",value: []
        },
        {
          titulo: "Receitas com Empréstimos de Valores Mobiliários",
          info: "",value: []
        },
        { titulo: "Rendimentos Auferidos em Operações de Mútuo", info: "",value: [] },
        { titulo: "Ganho de Ajustes a Valor Justo", info: "",value: [] },
        { titulo: "Outras Receitas Operacionais", info: "" ,value: []},
        {
          titulo: "TOTAL DEMAIS RECEITAS OPERACIONAIS (OUTRAS RECEITAS)",
          input: false,
          info: "",value: []
        },
      ],
      //14
      [
        { titulo: "Descontos concedidos", info: "",value: []},
        {
          titulo:
            "Despesas financeiras decorrentes do ajuste a valor presente",
          info: "",value: []
        },
        {
          titulo:
            "PIS/PASEP COFINS e Demais Impostos, Taxas e Contribuições de Bens e Instalações",
          info: "",value: []
        },
        { titulo: "Despesas Bancárias", info: "",value: [] },
        { titulo: "Variações Monetárias Passivas", info: "" ,value: []},
        { titulo: "Variações Cambiais Passivas", info: "",value: [] },
        { titulo: "Pagamento Juros Sobre Capital Próprio", info: "",value: [] },
        {
          titulo: "Resultado Negativo em Participações Societárias",
          info: "",value: []
        },
        {
          titulo:
            "Estimadas Decorrentes de Teste de Recuperabilidade (Impairment)",
          info: "",value: []
        },
        { titulo: "Perda na Alienação de Ativo Não Circulente", info: "",value: [] },
        { titulo: "Perda na Avaliação a Valor Justo", info: "",value: [] },
        { titulo: "Outras Despesas Operacionais", info: "" ,value: []},
        {
          titulo: "TOTAL DEMAIS DESPESAS OPERACIONAIS (OUTRAS DESPESAS)",
          input: false,
          info: "",value: []
        },
      ],
    ],
    meses: [ [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
    [[],[],[],[],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},],],
   //0  1  2  3  4                                                             5                                           6                                                                                                       7                                       
    ],
    ecfIrpj:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfIrpj2:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfIrpj3:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfIrpj4:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfIrpj5:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfCsll:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfCsll2:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfCsll3:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfCsll4:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfIpi:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
    ecfPrevidencia:[{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0},{valor:0}],
  },
  mutations: {
    increment(state) {
      state.step++
    }
  }
})
Vue.use(VModal, { componentName: "lefmodal" })
Vue.use(money);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Axios);
Vue.use(VueCookies);
Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  el: "#app",
  store: store,
  router,
  render: h => h(App)
});
